import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useGetAddressByNameQuery, useUpdateAddressMutation } from '../../../../store/api/address';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from "./Tab2"
import Attachment from '../../../../utils/Attachment';
function Address() {

    const navigate = useNavigate()
    const location = useLocation()
    const [apidata, setapidata] = useState('')
    const addressId = location?.state?.addressName
    console.log(addressId,"addid");
    

    const [companyAccounts, setSelectedCompanyAccounts] = useState('')
    const [tab, settab] = useState(1)
    const [res, setRes] = useState(false)
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const { data: addressdata, adderror, isLoading } = useGetAddressByNameQuery(addressId);

console.log(addressdata,"addressdata");


    const [updateAddress, { isuLoading, isSuccess, isError, uerror }] = useUpdateAddressMutation();
    const [isyca, setyca] = useState(0)
    useEffect(() => {
        if (addressdata?.data) {
            setapidata(addressdata?.data)
            const data = addressdata.data;
            setFormData({
                addressTitle: data.name || '',
                AddressType: data.address_type || '',
                AddressLine1: data.address_line1 || '',
                AddressLine2: data.address_line2 || '',
                Country: data.country || '',
                State: data.state || '',
                City: data.city || '',
                postalCode: data.pincode || '',
                email: data.email_id || '',
                phone: data.phone || '',
                Fax: data.fax || '',
                taxCategory: data.tax_category || '',
                pba: data.is_primary_address === 1,
                psa: data.is_shipping_address === 1,
                Disabled: data.disabled === 1,
                isyca: data.is_your_company_address === 1,
            });
        }
    }, [addressdata]);
    const [formdata, setFormData] = useState({
        addressTitle: '',
        AddressType: '',
        AddressLine1: '',
        AddressLine2: '',
        Country: '',
        City: '',
        State: '',
        postalCode: '',
        email: '',
        phone: '',
        Fax: '',
        taxCategory: '',
        pba: false,
        psa: false,
        Disabled: false,

    });
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };
	  const handleInputChange = (fieldName, value) => {
        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };
//  console.log(formdata,"formdata");
 
    
    const handleSubmit = async () => {
        const payload = {
            address_title: formdata.addressTitle,
            address_type: formdata.AddressType,
            address_line1: formdata.AddressLine1,
            address_line2: formdata.AddressLine2,
            city: formdata.City,
            state: formdata.State,
            country: formdata.Country,
            pincode: formdata.postalCode,
            email_id: formdata.email,
            phone: formdata.phone,
            fax: formdata.Fax,
            tax_category: formdata.taxCategory,
            is_primary_address: formdata.pba ? 1 : 0,
            is_shipping_address: formdata.psa ? 1 : 0,
            disabled: formdata.Disabled ? 1 : 0,
            links: companyAccounts,
            is_your_company_address: isyca ? 1 : 0
        }

        try {
            const res = await await updateAddress({
                addressName: addressId, 
                addressData: payload
            }).unwrap();
            setError('Address updated successfully!');
            setptype('Success');
            setShowError(true);
            setTimeout(() => {
                navigate('/master/address/address-list')
            }, 3000);

        } catch (error) {
            const parsedMessages = JSON.parse(error.data._server_messages);
            const firstMessageObj = JSON.parse(parsedMessages[0]);
            console.log(firstMessageObj, "errr");
            setError(firstMessageObj.message);
            setptype('Error');
            setShowError(true);
        }
    }

    return (
        <>
            <FormLayoutTwo
                title="Edit Address"
                breadcrumbs={[
                    { label: "Address" },
                    { label: "Address List", url: "/master/address/address-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSubmit}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}

                            iconSize={12}
                        // display={finalstep ? 'none' : 'flex'}
                        >
                            {/* {po_response.result ? 'Submit' : 'Save'} */}Update
                        </Button>

                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff" }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                             <Attachment doctype="Address"  docname={addressId}  />    
                        </div>
                    </div>


                          <div className=" " style={{ background: '' }}>
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="sidebarbox m-0">
                                                        <Tab1 formdata={formdata} handleChange={handleChange} setFormData={setFormData} apidata={apidata}  onInputChange={handleInputChange}/>
                                                    </div>
                                                    <div className="">
                                                        <Tab2 apidata={apidata} formdata={formdata} isyca={isyca} setyca={setyca} setSelectedCompanyAccounts={setSelectedCompanyAccounts} companyAccounts={companyAccounts} addressId={addressId}  onInputChange={handleInputChange}/>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>

                
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Address
